import axios from "axios";
import { url, awsUrl, newApiBaseUrl } from "../../axiosInstance";

export const getInventoriesPerMktOrBarcode = (mkt, barcode, tr, stationId) => {
  mkt = mkt ? mkt : 0;
  return axios.get(
    `${url}InventoryLocation/GetInventorysPerMktOrBarcode?mkt=${mkt}&barcode=${barcode}&whithEmptyPlace=${tr}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const multiMoves = (data) => {
  return axios.post(`${url}InventoryLocation/MultyMoves`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const updateProductBox = (data) => {
  return axios.post(`${url}Product/UpdateProductBox`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const updateDateEndSpecial = (data) => {
  return axios.post(`${url}InventoryLocation/UpdateDateEndSepcial`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const InventoryTransfers = async (data) => {
  const response = await fetch(`${newApiBaseUrl}/common/inventory-movements`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "x-tenant": "hamazon",
    },
    body: JSON.stringify(data),
  });
  return response;
};

export const InventoryBatches = (barcode, locationId) => {
  return axios.get(
    `${newApiBaseUrl}/common/inventory-batches?locationId=${locationId}&productId=${barcode}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const InventoryPerProduct = (barcode, locationId) => {
  return axios.get(
    `${newApiBaseUrl}/common/inventory-spots?locationId=${locationId}&productId=${barcode}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const fetchZonesByLocationId = async (locationId) => {
  return axios.get(`${newApiBaseUrl}/common/zones?locationId=${locationId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getInventorySpots = (zoneId) => {
  return axios.get(`${newApiBaseUrl}/common/inventory-spots?zoneId=${zoneId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getRcks = (zoneId) => {
  return axios.get(`${newApiBaseUrl}/common/racks?zoneId=${zoneId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getShelves = (rackId) => {
  return axios.get(`${newApiBaseUrl}/common/shelves?rackId=${rackId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getSpots = (shelfId) => {
  return axios.get(`${newApiBaseUrl}/common/spots?shelfId=${shelfId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getSaveLocations = (stationId) => {
  return axios.get(`${url}Inventory/GetSaveLocations?stationId=${stationId}`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const getIfProductPlaceFailedEmpty = (mkt) => {
  return axios.get(
    `${url}InventoryLocation/GetIfProductPlaceFailedsEmpty?mkt=${mkt}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const getEmptyPlace = (mkt, stationId) => {
  return axios.get(
    `${url}InventoryLocation/FindEmptyPlaces?mkt=${mkt}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};
export const getInventoryPerLocation = (Colmon, Row, Cell, stationId) => {
  return axios.get(
    `${url}Inventory/GetInventoryPerLocation?Colmon=${Colmon}&Row=${Row}&Cell=${Cell}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const getLocations = (stationId, stokeTypeId) => {
  const newStationId = stationId === "678430" ? 4 : stationId;
  let url = `${awsUrl}/v1/locations?stationId=${newStationId}`;
  if (stokeTypeId) url += `&stokeTypeId=${stokeTypeId}`;
  return axios.get(url, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const updateInventoryLocation = (data) => {
  data.stationId = data.stationId === "678430" ? 4 : data.stationId;
  return axios.put(`${awsUrl}/v1/products/location`, data, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const updateExpired = (data) => {
  return axios.put(`${awsUrl}/v1/products/location/expired`, data, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};
